import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  selectedTab: 0,
  selectedButton: "",
  // Control category of the selected tab ("Benchmark" / "Framework" / "MITRE").
  // A tab label alone is ambiguous (CIS exists under Benchmark and Framework) and
  // controls-by-parameter filters on both, so the flyout needs the category too.
  selectedCategory: "",
  // Control type from the posture row. Compliance tab clicks must not replace it,
  // because the Details tab uses this value for its own request.
  selectedControlType: "",
  row_id: "",
};

const tabSelectedSlice = createSlice({
  name: "tabSelected",
  initialState,
  reducers: {
    setTabSelected(state, action: PayloadAction<number>) {
      state.selectedTab = action.payload;
    },
    setButtonSelected(state, action: PayloadAction<string>) {
      state.selectedButton = action.payload;
      // A label set on its own (e.g. a row click) must not inherit the previous
      // tab's category; TabSelection sets the category right after the label.
      state.selectedCategory = "";
    },
    setCategorySelected(state, action: PayloadAction<string>) {
      state.selectedCategory = action.payload;
    },
    setSelectedControlType(state, action: PayloadAction<string>) {
      state.selectedControlType = action.payload;
    },
    setSelectedRowID(state, action: PayloadAction<string>) {
      state.row_id = action.payload;
    },
  },
});

export const { setTabSelected, setButtonSelected, setCategorySelected, setSelectedControlType, setSelectedRowID } =
  tabSelectedSlice.actions;
export default tabSelectedSlice.reducer;
